import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FaSpinner } from "react-icons/fa";
var Loading = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full h-300p flex justify-center items-center",
        children: /*#__PURE__*/ _jsx(FaSpinner, {
            className: "animate-spin h-10 w-10 text-primary"
        })
    });
};
export default Loading;
